<div class="quick-links-container" *ngIf="showQuickLinks && isAuthenticated">
  <div class="quick-links-header">
    <div class="header-content">
      <div class="header-icon">
        <mat-icon>rocket_launch</mat-icon>
      </div>
      <div class="header-text">
        <h3>Quick Actions</h3>
        <span class="header-subtitle">Navigate faster with shortcuts</span>
      </div>
    </div>
    <button mat-icon-button class="close-button" (click)="toggleQuickLinks()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="quick-links-content">
    <div class="quick-link-item"
         *ngFor="let link of quickLinks; let i = index"
         (click)="activateQuickLink(link)"
         [style.animation-delay]="(i * 0.05) + 's'">
      <div class="quick-link-key" [class.special-key]="link.key === 'F1'">
        {{ link.key }}
      </div>
      <div class="quick-link-info">
        <div class="icon-container">
          <mat-icon *ngIf="link.icon">{{ link.icon }}</mat-icon>
        </div>
        <div class="link-text">
          <span class="link-title">{{ link.description }}</span>
          <span class="link-subtitle" *ngIf="getSubtitle(link)">{{ getSubtitle(link) }}</span>
        </div>
      </div>
      <div class="quick-link-arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </div>
  </div>

  <div class="quick-links-footer">
    <div class="footer-content">
      <div class="help-text">
        <mat-icon>help_outline</mat-icon>
        <span>Press <span class="key">?</span> to toggle this panel</span>
      </div>
      <div class="footer-stats">
        {{ quickLinks.length }} shortcuts available
      </div>
    </div>
  </div>
</div>

<div class="quick-links-toggle" *ngIf="!showQuickLinks && isAuthenticated" (click)="toggleQuickLinks()">
  <div class="toggle-icon">
    <mat-icon>keyboard</mat-icon>
  </div>
  <div class="toggle-pulse"></div>
</div>
